import {
    ListTableColumn,
    createListTableColumns,
    renderBooleanIconWithTooltip,
    renderBooleanIcon,
    renderClickableLink
} from "sprint-common-web";

import { AddSeasonToMergeListButton } from "./buttons/AddSeasonToMergeListButton";
import { ViewSeasonAssetButton } from "./buttons/ViewSeasonAssetButton";
import { SeasonListingItem } from "./SeasonListingItem";

export const createSeasonLisingColumns = (
    onSeasonSelected: (season?: SeasonListingItem) => void
): ListTableColumn<SeasonListingItem>[] =>
    createListTableColumns<SeasonListingItem>([
        {
            type: "interactive",
            key: "name",
            name: "Name",
            minWidth: 70,
            maxWidth: 350,
            isSortable: true,
            isDisabled: (item) => item.merged || false,
            onItemInvoked: onSeasonSelected,
            onRender: renderClickableLink
        },
        {
            type: "basic",
            key: "number",
            name: "Number",
            minWidth: 65,
            maxWidth: 65,
            isSortable: true
        },
        {
            type: "basic",
            key: "orphaned",
            name: "Orphaned",
            minWidth: 65,
            maxWidth: 65,
            isSortable: false,
            onRender: (item?: SeasonListingItem, number?: number, column?: ListTableColumn<unknown>) =>
                renderBooleanIconWithTooltip(item, number, column, item?.orphanedDetails)
        },
        {
            type: "basic",
            key: "merged",
            name: "Merged",
            minWidth: 65,
            maxWidth: 65,
            isSortable: false,
            onRender: renderBooleanIcon
        },
        {
            type: "buttons",
            key: "actions",
            name: "Actions",
            minWidth: 64,
            maxWidth: 96,
            buttons: [
                {
                    id: "viewAssets",
                    render: ViewSeasonAssetButton
                },
                {
                    id: "AddSeasonToMergeList",
                    render: AddSeasonToMergeListButton
                }
            ]
        }
    ]);
